export const CHECKOUT = 'checkout';
export const CART = 'cart';
export const LOGIN = 'login';
export const ACCOUNT_LANDING = 'accountLanding';
export const ORDER = 'order';
export const GUEST_ORDER = 'guestOrder';
export const SHIPPING = 'shipping';
export const PAYMENT = 'payment';
